var version = {
    "name":      "dativery",
    "buildDateCode": "20260831-141754",
    "buildDate": "Mon Aug 31 2026 14:17:54 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260831-141754",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;